import React from 'react';
import Rating from '@material-ui/lab/Rating';

import EmptyIcon from '../../../../assets/images/icons/icons_stars_inactive_lrg.svg';
import FullIcon from '../../../../assets/images/icons/icons_stars_active_lrg.svg';

import * as defaultStyles from './styles/default.module.scss';
import * as filterStyles from './styles/filter.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

// Note: StarRating component renders very inefficiently when loading multiple stars on trail result cards in fullscreen search result list,
// TODO: Let's look at using a different framework or building this custom
export default function StarRating({ handler, config, iconClassName }) {
  const styles = handler ? filterStyles : defaultStyles;

  return (
    <Rating
      className={styles.rating}
      name="rating"
      size="large"
      value={parseFloat(config)}
      onChange={handler}
      icon={<img className={iconClassName} alt={StringConstantsMixin.strings.ALT_TEXT.YELLOW_STAR} src={FullIcon} />}
      emptyIcon={<img className={iconClassName} alt={StringConstantsMixin.strings.ALT_TEXT.GRAY_STAR} src={EmptyIcon} />}
      precision={handler ? 1 : 0.5}
      readOnly={!handler}
    />
  );
}

StarRating.defaultProps = {
  iconClassName: ''
};
